import { useNavigate } from 'react-router';

import { PartnerApplicationMachineContext } from '~domains/partner-application/entities/application';
import { getApplicationEventProperties } from '~domains/partner-application/shared/lib';
import { AgentForm } from '~domains/partner-application/widgets/agents-block/ui/agent-form/agent-form';
import { AgentsList } from '~domains/partner-application/widgets/agents-block/ui/agents-list/agents-list';

import { ampli } from '~entities/ampli';

import { ROUTES } from '~shared/config/routes';

import { AgentsStart } from './agents-start';

import { useApplicationActions } from '../../partner-application';

export const AgentsBlock = () => {
  const navigate = useNavigate();
  const state = PartnerApplicationMachineContext.useSelector((s) => s);

  const agents = PartnerApplicationMachineContext.useSelector(
    (snapshot) => snapshot.context.agents
  );
  const pointsOfSales = PartnerApplicationMachineContext.useSelector(
    (snapshot) => snapshot.context.pointsOfSales
  );
  const agentDraft = PartnerApplicationMachineContext.useSelector(
    (snapshot) => snapshot.context.agentDraft
  );
  const applicationId = PartnerApplicationMachineContext.useSelector(
    (snapshot) => snapshot.context.applicationId
  );
  const actor = PartnerApplicationMachineContext.useActorRef();
  const { updateApplication } = useApplicationActions();

  const onBack = () => actor.send({ type: 'back' });
  const onClose = () => navigate(ROUTES.partner.applicationMenu);

  if (!state.matches('agentsBlock')) return null;

  if (state.matches({ agentsBlock: 'agentsStart' })) {
    return (
      <AgentsStart
        onSubmit={() => {
          ampli.mpPaAgentsStartScreenNextClick(
            getApplicationEventProperties(applicationId)
          );
          actor.send({ type: 'next' });
        }}
        onBack={() => {
          ampli.mpPaAgentsStartScreenBackClick(
            getApplicationEventProperties(applicationId)
          );
          onBack();
        }}
        onClose={() => {
          ampli.mpPaAgentsStartScreenCloseClick(
            getApplicationEventProperties(applicationId)
          );
          onClose();
        }}
      />
    );
  }

  return (
    <>
      {state.matches({ agentsBlock: 'agentsList' }) && (
        <AgentsList
          applicationId={applicationId}
          agents={agents}
          pointsOfSales={pointsOfSales}
          onSubmit={() => {
            ampli.mpPaAgentListScreenNextClick(
              getApplicationEventProperties(applicationId)
            );
            actor.send({ type: 'next' });
          }}
          onBack={() => {
            ampli.mpPaAgentListScreenBackClick(
              getApplicationEventProperties(applicationId)
            );
            onBack();
          }}
          onEditAgent={(agentId) => {
            ampli.mpPaAgentListEditAgentClick(
              getApplicationEventProperties(applicationId)
            );
            actor.send({ type: 'agent.edit', agentId });
          }}
          onAddAgent={() => actor.send({ type: 'agent.add' })}
          onClose={() => {
            ampli.mpPaAgentListScreenCloseClick(
              getApplicationEventProperties(applicationId)
            );
            onClose();
          }}
          onRemoveAgent={async (agentId: string) => {
            ampli.mpPaAgentListDeleteAgentClick(
              getApplicationEventProperties(applicationId)
            );
            actor.send({ type: 'agent.remove', agentId });
            await updateApplication();
          }}
        />
      )}
      {state.matches({ agentsBlock: { agentEdit: 'agentForm' } }) && (
        <AgentForm
          agentDraft={agentDraft}
          pointsOfSales={pointsOfSales}
          onSubmit={async (values) => {
            ampli.mpPaAgentInfoScreenNextClick(
              getApplicationEventProperties(applicationId)
            );
            actor.send({ type: 'agentForm.submitData', agent: values });
            await updateApplication();
            actor.send({ type: 'next' });
          }}
          onBack={() => {
            ampli.mpPaAgentInfoScreenBackClick(
              getApplicationEventProperties(applicationId)
            );
            onBack();
          }}
          onClose={() => {
            ampli.mpPaAgentInfoScreenCloseClick(
              getApplicationEventProperties(applicationId)
            );
            onClose();
          }}
        />
      )}
    </>
  );
};
